// 用户登录
export async function login(username: string, pwd: string) {
  return await $axios.post('/api/login', { username, password: pwd, isEncrypt: true })
}

// 获取商户初始化信息
export async function getInitData() {
  return await $axios.get('/api/store/initData')
}

// 保存商户基本信息
export async function saveBasicInfo(data: any) {
  return await $axios.put(`/api/store/saveBasicInfo`, data)
}

/**
 * 保存小程序相关数据
 * @param data 小程序相关数据
 * @returns 
 */
export async function saveProgram(data: any) {
  return await $axios.put(`/api/store/saveProgram/${$app.store?.id}`, data)
}

/**
 * 修改密码
 * @param data 新密码
 * @returns 
 */
export async function updatePassword(data: any) {
  return await $axios.put(`/api/store/updatePassword/${$app.store?.id}`, { isEncrypt: true, ...data })
}

/**
 * 保存logo
 * @param data logo相关数据
 * @returns 
 */
export async function updateLogo(data: any) {
  return await $axios.post(`/api/store/updateLogo/${$app.store?.id}`, data)
}

/**
 * 修改商户商品分类
 * @param data 商品分类列表
 * @returns 
 */
export async function updateGoodCategory(data: DataDic[]) {
  return await $axios.put(`/api/store/goodCategory/${$app.store?.id}`, data)
}

/**
 * 获取商户下所有的门店
 * @returns 
 */
export async function getStores() {
  return await $axios.get(`/api/store/children`)
}

/**
 * 创建或修改商户信息
 */
export async function createOrUpdateStore(data: any) {
  return await $axios.post(`/api/store/createOrUpdate`, data)
}

/**
 * 绑定商户
 */
export async function bindStore(code: string) {
  return await $axios.put(`/api/store/bind/${code}`)
}

/**
 * 解绑商户
 */
export async function unBindStore(code: string) {
  return await $axios.put(`/api/store/unBind/${code}`)
}

/**
 * 重置密码
 */
export async function resetPassword(data: any) {
  return await $axios.put(`/api/store/resetPwd`, data)
}

/**
 * 进入门店
 */
export async function enterStore(id: string) {
  return await $axios.get(`/api/store/enter/${id}`)
}

/**
 * 获取简单的下属门店信息
 */
export async function getSimpleStore() {
  return await $axios.get(`/api/store/simple`)
}

/**
 * 获取门店设置的支付方式
 */
export async function getPayments(id: string) {
  return await $axios.get(`/api/store/payments/` + id)
}

/**
 * 获取会员列表
 * @param dto 
 * @returns 
 */
export async function getMembers(dto: QueryMember) {
  return await $axios.post<{ total: number, members: Member[] }>(`/api/store/members`, dto)
}

/**
 * 获取系统API版本号
 */
export async function getApiVersion() {
  return await $axios.get(`/api/client/version`)
}

/**
 * 获取收银台版本号
 */
export async function getCacherVersion() {
  return await $axios.get(`/api/client/cashierVersion`)
}

/**
 * 获取公众号二维码
 */
export async function getStoreQrcode() {
  return await $axios.get(`/api/store/mpQrcode`)
}

/**
 * 获取门店已绑定公众号的用户
 */
export async function getMpBindingUsers() {
  return await $axios.get(`/api/store/mpUsers`)
}

/**
 * 获取门店绑定小程序的用户
 */
export async function getWechatBindingUsers(id: string) {
  return await $axios.get(`/api/store/wechatUsers/` + id)
}

/**
 * 删除门店绑定小程序的用户
 */
export async function removeWechatBindingUsers(id: string) {
  return await $axios.delete(`/api/store/wechatUsers/` + id)
}

/**
 * 根据会员卡号获取会员信息
 */
export async function getMemberByCode(code: string) {
  return await $axios.get(`/api/store/member/${code}`)
}

/**保存第三方平台配置信息 */
export async function savePlatformInfo(data: any) {
  return await $axios.post(`/api/store/savePlatformInfo/${$app.store?.id}`, data)
}